"use client"
import React from "react"
import { Button } from "../../components/ui/button"
import { Globe } from "lucide-react"
import { useLanguage } from "../contexts/language-context"

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage()

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "es" : "en")
  }

  // Show the target language code (opposite of the current language)
  const targetLangCode = language === "en" ? "ES" : "EN"

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="focus-ring flex items-center gap-2"
      aria-label={`Change language to ${language === "en" ? "Spanish" : "English"}`}
    >
      <Globe className="h-4 w-4" />
      <span className="font-medium">{targetLangCode}</span>
    </Button>
  )
}
